import PropTypes from 'prop-types';
import React from 'react';
import updateDesign from '../../actions/update-design';
import reportDesign from '../../actions/report-design';
import constants from 'contest/data/constants';

export default function DesignAction(InnerComponent) {
    class DesignActionContainer extends React.Component {
        constructor(props) {
            super(props);

            this.handleUpdate = this.handleUpdate.bind(this);
            this.handleDropdownSelect = this.handleDropdownSelect.bind(this);
            this.eliminateDesign = this.eliminateDesign.bind(this);
            this.deleteDesign = this.deleteDesign.bind(this);
            this.withdrawDesign = this.withdrawDesign.bind(this);
            this.awardWinner = this.awardWinner.bind(this);
            this.addToFolio = this.addToFolio.bind(this);
            this.undoEliminate = this.undoEliminate.bind(this);
            this.undoWithdraw = this.undoWithdraw.bind(this);
            this.undoDelete = this.undoDelete.bind(this);
            this.reportDesign = this.reportDesign.bind(this);
        }

        handleUpdate(newData) {
            const payload = {
                design: this.props.design,
                data: newData,
            };

            this.context.executeAction(updateDesign, payload);
        }

        handleDropdownSelect(data) {
            switch (data.key) {
                case constants.WITHDRAW_DESIGN:
                    this.withdrawDesign();
                    break;
                case constants.AWARD_WINNER:
                    this.awardWinner();
                    break;
                case constants.ADD_TO_FOLIO:
                    this.addToFolio();
                    break;
                case constants.REPORT_DESIGN:
                    this.reportDesign();
                    break;
            }
        }

        eliminateDesign() {
            this.handleUpdate({ is_eliminated: 1 });
        }

        deleteDesign() {
            this.handleUpdate({ is_deleted: 1 });
        }

        withdrawDesign() {
            this.handleUpdate({ is_withdrawn: 1 });
        }

        addToFolio() {
            window.location.href = this.props.design.links.addToFolio;
        }

        reportDesign() {
            const payload = {
                design: this.props.design,
            };

            this.context.executeAction(reportDesign, payload);
        }

        awardWinner() {
            const { design } = this.props;

            const massagedDesigner = {
                avatarUrl: design.creator.avatarUrl,
                displayName: design.creator.name,
            };

            const massageEntry = {
                contestEntryId: design.entryId,
                hasPurchasableStock: design.stockDeclarations > 0,
                imageUrl: design.previewUrl,
                awardUrl: design.links.awardDesign,
                user: massagedDesigner,
            };

            const entries = [massageEntry];

            window.dispatchEvent(
                new window.CustomEvent('openAwardWinnerModal', { detail: entries })
            );
        }

        undoEliminate() {
            this.handleUpdate({ is_eliminated: 0 });
        }

        undoWithdraw() {
            this.handleUpdate({ is_withdrawn: 0 });
        }

        undoDelete() {
            this.handleUpdate({ is_deleted: 0 });
        }

        render() {
            return (
                <InnerComponent
                    {...this.props}
                    ref={(nestedNode) => {
                        if (nestedNode && nestedNode.awardNode) {
                            this.awardNode = nestedNode.awardNode;
                        }
                    }}
                    onUpdate={this.handleUpdate}
                    onDropdownSelect={this.handleDropdownSelect}
                    onEliminateDesign={this.eliminateDesign}
                    onDeleteDesign={this.deleteDesign}
                    onWithdrawDesign={this.withdrawDesign}
                    onAddToFolio={this.addToFolio}
                    onAwardWinner={this.awardWinner}
                    onUndoEliminate={this.undoEliminate}
                    onUndoWithdraw={this.undoWithdraw}
                    onUndoDelete={this.undoDelete}
                    onReportDesign={this.reportDesign}
                />
            );
        }
    }

    DesignActionContainer.contextTypes = {
        executeAction: PropTypes.func.isRequired,
    };

    DesignActionContainer.propTypes = {
        design: PropTypes.object.isRequired,
    };

    return DesignActionContainer;
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/connected/design-action.jsx